import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "orders-page" }
const _hoisted_2 = { class: "orders-page__content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "orders-page__loader"
}
const _hoisted_5 = {
  key: 1,
  class: "orders-page__empty"
}
const _hoisted_6 = {
  key: 2,
  class: "orders-list"
}

import AppHeader from '@/components/AppHeader.vue';
import OrderCard from '@/components/OrderCard.vue';
import useOrdersStore from '@/store/orders';
import AppLoader from '@/components/AppLoader.vue';
import { onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useTelegramWebApp } from '@/services/telegram-web-app';
import AppBtn from '@/components/AppBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersPage',
  setup(__props) {

const telegramWebApp = useTelegramWebApp();
const ordersStore = useOrdersStore();

if (!ordersStore.isOrdersLoaded && !ordersStore.isLoadingOrders) {
  ordersStore.loadOrders();
}

onMounted(() => {
  telegramWebApp.hideMainBtn();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      "with-search": false,
      title: _ctx.$t('orderHistory')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(ordersStore).isLoadingOrders)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(AppLoader)
            ]))
          : (_unref(ordersStore).orders.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t('orderIsEmpty')) + " ", 1),
                _createVNode(AppBtn, {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/')), ["prevent"])),
                  class: "orders-page__empty-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('goShopping')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ordersStore).orders, (order) => {
                  return (_openBlock(), _createBlock(OrderCard, {
                    key: order.orderId,
                    order: order
                  }, null, 8, ["order"]))
                }), 128))
              ]))
      ])
    ])
  ]))
}
}

})